<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getTutorfiles(to.params.id)
      // vm.getTutors(to.params.id)
    })
  },
  methods: {
    // getTutorfiles (id) {
    //   this.$store.dispatch('getTutorfiles', id)
    // },
    // getTutors (id) {
    //   this.$store.dispatch('getTutorsLimit10', id)
    // }
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Tutorfiles.vue?3d7f3240